module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/gastos/gastos.component.scss
// module id = ./src/app/components/gastos/gastos.component.scss
// module chunks = main